module.exports = __webpack_public_path__ + "static/media/Alicia P.3a80636a.jpg";